export default __webpack_public_path__ + "static/media/Claims_Proceedures.22d915a0.pdf";